module.exports = __webpack_public_path__ + "static/media/Digilicious-01.c1b6f810.png";